const PROPERTIES = {
  BASEURL: "https://pinseriabe.onrender.com/api/",
  // TIMEOUT: 10000,
};

export default PROPERTIES;
